<div
  class="
    d-inline-flex
    align-items-center
    justify-content-center
    gap-2
  "
>
  <span class="fw-bold text-body">
    {{ label() }}
  </span>

  <span
    class="
      d-inline-flex
      flex-column
      align-items-center
      justify-content-center
      lh-1
    "
  >
    <button
      type="button"
      class="
        btn
        border-0
        p-0
        lh-1
        shadow-none
      "
      [attr.aria-pressed]="isAscending()"
      (click)="sort('asc')"
    >
      <i
        class="icon-chevron-up fs-7"
        [class.text-primary]="isAscending()"
        [class.text-muted]="!isAscending()"
        [class.fw-bold]="isAscending()"
        [class.fw-normal]="!isAscending()"
      ></i>
    </button>

    <button
      type="button"
      class="
        btn
        border-0
        p-0
        lh-1
        shadow-none
      "
      [attr.aria-pressed]="isDescending()"
      (click)="sort('desc')"
    >
      <i
        class="icon-chevron-down fs-7"
        [class.text-primary]="isDescending()"
        [class.text-muted]="!isDescending()"
        [class.fw-bold]="isDescending()"
        [class.fw-normal]="!isDescending()"
      ></i>
    </button>
  </span>
</div>
